export default __webpack_public_path__ + "static/media/gallery (21).88443de2.png";